import { render, staticRenderFns } from "./cSammelliste.vue?vue&type=template&id=3b934074&scoped=true"
import script from "./cSammelliste.vue?vue&type=script&lang=js"
export * from "./cSammelliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b934074",
  null
  
)

export default component.exports